import { initArgus } from "@solvari/common-fe/argus/service";

import type { SolvariEnv } from "@solvari/utils";

import "@solvari/common-fe/polyfills";

function hardcodedEnv() {
  globalThis.solvariEnv = {
    auth: {
      jwtToken: null,
      attributionUserId: null,
    },
    config: {
      localeCode: "nl-NL",
      lang: "nl",
      urlPrefix: "",
      envBE: "production",
      envType: "production",
      translationsTimestamp: 1754562714,
      themeId: null,
    },
    integrations: {
      algolia: { applicationId: "", env: "dev", publicSearchApiKey: "" },
      pusher: { appId: "", key: "", cluster: "" },
    },
    network: {
      admin: "https://admin.solvari.nl",
      api: "https://api.solvari.nl",
      argus: "https://argus.solvari.nl",
      static: "https://static.solvari.nl",
      client: {
        base: "https://www.solvari.nl",
        baseWithPrefix: "https://www.solvari.nl",
      },
      pro: {
        base: "https://pro.solvari.nl",
        baseWithPrefix: "https://pro.solvari.nl",
      },
    },
  } satisfies SolvariEnv;
}

function main() {
  hardcodedEnv();
  void initArgus();
}

main();
